import type { ja } from '.'

// キーと値の間に改行が入ると翻訳システムと連携できなくなるため、prettier-ignoreしている
// prettier-ignore
export const locale = {
  'smarthr-ui/common/language': 'Tiếng Nhật',
  'smarthr-ui/ActionDialog/closeButtonLabel': 'Hủy',
  'smarthr-ui/AppHeader/school': 'Lớp học',
  'smarthr-ui/AppHeader/help': 'Hỗ trợ',
  'smarthr-ui/AppHeader/userSettings': 'Cài đặt cá nhân',
  'smarthr-ui/AppHeader/releaseNotes': 'Release Note',
  'smarthr-ui/AppHeader/releaseNotesLoadError': 'Thất bại trong việc tải Release Note. Hãy thử lại sau một lúc nữa.',
  'smarthr-ui/AppHeader/seeAllReleaseNotes': 'Xem tất cả các Release note',
  'smarthr-ui/AppHeader/DesktopHeader/appLauncherLabel': 'Tính năng',
  'smarthr-ui/AppHeader/MobileHeader/account': 'Tài khoản',
  'smarthr-ui/AppHeader/MobileHeader/openMenu': 'Mở menu',
  'smarthr-ui/AppHeader/MobileHeader/closeMenu': 'Đóng menu',
  'smarthr-ui/AppHeader/MobileHeader/allAppButton': 'Tất cả Tính năng',
  'smarthr-ui/AppHeader/MobileHeader/managementMenu': 'Menu quản lý',
  'smarthr-ui/AppHeader/MobileHeader/latestReleaseNotes': 'Release note mới nhất',
  'smarthr-ui/AppHeader/MobileHeader/back': 'Quay lại',
  'smarthr-ui/AppHeader/MobileHeader/openMenuAccordion': 'Mở',
  'smarthr-ui/AppHeader/MobileHeader/closeMenuAccordion': 'Đóng',
  'smarthr-ui/AppHeader/Launcher/searchInputTitle': 'Nhập tên tính năng.',
  'smarthr-ui/AppHeader/Launcher/favoriteModeText': 'Tính năng thường dùng',
  'smarthr-ui/AppHeader/Launcher/allModeText': 'Tất cả Tính năng',
  'smarthr-ui/AppHeader/Launcher/listText': 'Danh sách các tính năng',
  'smarthr-ui/AppHeader/Launcher/helpText': 'Tính năng thường dùng là gì',
  'smarthr-ui/AppHeader/Launcher/searchResultText': 'Kết quả tìm kiếm',
  'smarthr-ui/AppHeader/Launcher/emptyText': 'Không tìm thấy tính năng tương thích.',
  'smarthr-ui/AppHeader/Launcher/sortDropdownLabel': 'Thứ tự hiển thị',
  'smarthr-ui/AppHeader/Launcher/sortDropdownSelected': 'Đang lựa chọn',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderDefault': 'Mặc định',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameAsc': 'Tên tính năng (A→Z）',
  'smarthr-ui/AppHeader/Launcher/sortDropdownOrderNameDesc': 'Tên tính năng (Z→A）',
  'smarthr-ui/AppLauncher/showAllText': 'Xem tất cả',
  'smarthr-ui/AppLauncher/triggerLabel': 'Tính năng',
  'smarthr-ui/Browser/notFoundDescription': 'Hãy thử một điều kiện khác.',
  'smarthr-ui/Browser/notFoundTitle': 'Không có mục phù hợp.',
  'smarthr-ui/Button/loading': 'Đang xử lý',
  'smarthr-ui/Calendar/currentYear': 'Năm hiện tại',
  'smarthr-ui/Calendar/nextMonth': 'Tháng sau',
  'smarthr-ui/Calendar/previousMonth': 'Tháng trước',
  'smarthr-ui/Calendar/selectYear': 'Chọn năm',
  'smarthr-ui/Combobox/addItemButtonLabel': 'Thêm "{name}"',
  'smarthr-ui/Combobox/loadingText': 'Đang xử lý',
  'smarthr-ui/Combobox/noResultsText': 'Không có kết quả phù hợp.',
  'smarthr-ui/DropdownMenuButton/triggerActive': 'Đóng danh sách gợi ý',
  'smarthr-ui/DropdownMenuButton/triggerInactive': 'Mở danh sách gợi ý',
  'smarthr-ui/DropZone/selectButtonLabel': 'Chọn tệp',
  'smarthr-ui/FileViewer/rotateAlt': 'Quay trái',
  'smarthr-ui/FileViewer/scaleDownAlt': 'Thu nhỏ',
  'smarthr-ui/FileViewer/scaleRateLabel': 'Tỷ lệ',
  'smarthr-ui/FileViewer/scaleUpAlt': 'Phóng to',
  'smarthr-ui/FileViewer/unsupportedFileText': 'Định dạng tệp không được hỗ trợ.',
  'smarthr-ui/FilterDropdown/applyText': 'Áp dụng',
  'smarthr-ui/FilterDropdown/cancelText': 'Hủy',
  'smarthr-ui/FilterDropdown/resetText': 'Hủy điều kiện lọc',
  'smarthr-ui/FilterDropdown/status': 'Đang áp dụng',
  'smarthr-ui/FilterDropdown/triggerText': 'Lọc',
  'smarthr-ui/FormDialog/closeButtonLabel': 'Hủy',
  'smarthr-ui/InformationPanel/closeButtonLabel': 'Đóng',
  'smarthr-ui/InformationPanel/openButtonLabel': 'Mở',
  'smarthr-ui/InputFile/destroy': 'Xóa',
  'smarthr-ui/LanguageSwitcher/checkIconAlt': 'Đang chọn',
  'smarthr-ui/Loader/alt': 'Đang xử lý',
  'smarthr-ui/MessageDialog/closeButtonLabel': 'Đóng',
  'smarthr-ui/ModelessDialog/closeButtonIconAlt': 'Đóng',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaLabel': 'Vị trí của hộp thoại',
  'smarthr-ui/ModelessDialog/dialogHandlerAriaRoleDescription': 'Có thể kéo',
  'smarthr-ui/ModelessDialog/dialogHandlerDescription': 'Có thể di chuyển lên xuống trái phải bằng phím mũi tên',
  'smarthr-ui/ModelessDialog/dialogHandlerLiveRegionText': 'Từ trên xuống {top}px, từ trái sang {left}px',
  'smarthr-ui/MultiCombobox/destroyButtonIconAltSuffix': ': Xoá',
  'smarthr-ui/MultiCombobox/selectedListAriaLabel': 'Mục đã chọn',
  'smarthr-ui/NotificationBar/closeButtonIconAlt': 'Đóng',
  'smarthr-ui/Pagination/controllerItemButtonFirstLabel': 'Trở về đầu',
  'smarthr-ui/Pagination/controllerItemButtonLastLabel': 'Đi đến cuối',
  'smarthr-ui/Pagination/controllerItemButtonNextLabel': 'Tiếp theo',
  'smarthr-ui/Pagination/controllerItemButtonPreviousLabel': 'Quay lại',
  'smarthr-ui/Pagination/itemButtonLabel': 'Trang {page}',
  'smarthr-ui/Pagination/navigationLabel': 'Phân trang',
  'smarthr-ui/RequiredLabel/text': 'Bắt buộc',
  'smarthr-ui/SearchInput/iconAlt': 'Tìm',
  'smarthr-ui/SideMenu/navigationLabel': 'Side Menu',
  'smarthr-ui/SingleCombobox/destroyButtonIconAlt': 'Xóa',
  'smarthr-ui/SortDropdown/applyText': 'Áp dụng',
  'smarthr-ui/SortDropdown/ascLabel': 'Tăng dần',
  'smarthr-ui/SortDropdown/cancelText': 'Hủy',
  'smarthr-ui/SortDropdown/descLabel': 'Giảm dần',
  'smarthr-ui/SortDropdown/sortFieldLabel': 'Mục sắp xếp',
  'smarthr-ui/SortDropdown/sortOrderLegend': 'Thứ tự sắp xếp',
  'smarthr-ui/StepFormDialog/backButtonLabel': 'Quay lại',
  'smarthr-ui/StepFormDialog/closeButtonLabel': 'Hủy',
  'smarthr-ui/StepFormDialog/nextButtonLabel': 'Tiếp theo',
  'smarthr-ui/StepStatusIcon/closedAlt': 'Ngưng',
  'smarthr-ui/StepStatusIcon/completedAlt': 'Hoàn thành',
  'smarthr-ui/Textarea/availableLetters': 'Còn {availableLetters} ký tự nữa',
  'smarthr-ui/Textarea/maxLettersExceeded': 'Thửa {exceededLetters} ký tự',
  'smarthr-ui/Textarea/screenReaderMaxLettersDescription': 'Có thể nhập tối đa {maxLetters} ký tự.',
  'smarthr-ui/OpenInNewTabIcon/openInNewTab': 'Mở trong tab mới',
  'smarthr-ui/Th/sortDirectionAsc': 'Tăng dần',
  'smarthr-ui/Th/sortDirectionDesc': 'Giảm dần',
  'smarthr-ui/Th/sortDirectionNone': 'Không sắp xếp',
  'smarthr-ui/ThCheckbox/checkAllInvisibleLabel': 'Chọn/Bỏ chọn tất cả các mục',
  'smarthr-ui/ThCheckbox/checkColumnName': 'Chọn',
} as const satisfies Record<keyof typeof ja, string>
